
import { Component, Vue } from "vue-property-decorator";
import TheHeader from "@/components/TheHeader.vue";
import TheFooter from "@/components/TheFooter.vue";
import { getAllProducts, getAllComments } from "@/api/mainRequests";

@Component({
  components: {
    TheHeader,
    TheFooter,
  },
})
export default class App extends Vue {
  unSubscribe!: () => void;

  synchronizeStateAndStore() {
    this.unSubscribe = this.$store.subscribe((mutation, state) => {
      localStorage.setItem("store", JSON.stringify({ ...state }));
    });
  }

  async mounted() {
    await getAllProducts();
    await getAllComments();
    this.synchronizeStateAndStore();
  }

  destroyed() {
    this.unSubscribe();
  }
}
